module.exports = __webpack_public_path__ + "static/media/group.5347ebf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/group.svg
// module id = 258
// module chunks = 0